// Dashboard — cross-partner counters + last 10 audit entries.
// No charts here — those are on /monitoring.

import { useEffect, useState } from "react";
import { gql } from "../lib/gql";

type AdminStats = {
  partnersCount: number;
  pointsCount: number;
  devicesCount: number;
  flatsCount: number;
  // Все учётные записи жильцов, включая людей без адреса и удаливших аккаунт.
  residentsCount: number;
  // Жильцы с действующим доступом к квартирам, по одному на человека.
  activeResidentsCount: number;
};

type AuditEntry = {
  id: number;
  userEmail: string | null;
  action: string;
  targetType: string | null;
  targetId: string | null;
  createdAt: string;
};

export function DashboardPage() {
  const [stats, setStats] = useState<AdminStats | null>(null);
  const [audit, setAudit] = useState<AuditEntry[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const data = await gql<{
          adminStats: AdminStats;
          adminAuditLogs: AuditEntry[];
        }>(`
          query Dashboard {
            adminStats {
              partnersCount
              pointsCount
              devicesCount
              flatsCount
              residentsCount
              activeResidentsCount
            }
            adminAuditLogs(limit: 10) {
              id
              userEmail
              action
              targetType
              targetId
              createdAt
            }
          }
        `);
        setStats(data.adminStats);
        setAudit(data.adminAuditLogs);
      } catch (err) {
        setError(err instanceof Error ? err.message : String(err));
      }
    })();
  }, []);

  return (
    <div>
      <h2>Дашборд</h2>
      {error && <div className="error-banner">{error}</div>}

      <div className="stats-grid">
        <StatCard label="Партнёров" value={stats?.partnersCount} />
        <StatCard label="Точек установки" value={stats?.pointsCount} />
        <StatCard label="Устройств" value={stats?.devicesCount} />
        <StatCard label="Квартир" value={stats?.flatsCount} />
        <StatCard label="Жильцов с доступом" value={stats?.activeResidentsCount} />
        <StatCard label="Учётных записей жильцов" value={stats?.residentsCount} />
      </div>

      <div className="card">
        <h3 style={{ margin: "0 0 12px 0" }}>Последние действия</h3>
        {audit.length === 0 ? (
          <div className="muted">Пока пусто — admin action'ы появятся здесь.</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Когда</th>
                <th>Кто</th>
                <th>Действие</th>
                <th>Объект</th>
              </tr>
            </thead>
            <tbody>
              {audit.map((e) => (
                <tr key={e.id}>
                  <td>{new Date(e.createdAt).toLocaleString("ru-RU")}</td>
                  <td>{e.userEmail || <span className="muted">—</span>}</td>
                  <td>{e.action}</td>
                  <td className="muted">
                    {e.targetType}
                    {e.targetId ? `: ${e.targetId.slice(0, 8)}…` : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function StatCard({ label, value }: { label: string; value: number | undefined }) {
  return (
    <div className="stat-card">
      <div className="label">{label}</div>
      <div className="value">{value ?? "…"}</div>
    </div>
  );
}
